module.exports = __webpack_public_path__ + "img/leakalert_battery.03b7093a.jpg";